import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../../Extra/Loading";
import { FaUpload } from "react-icons/fa";
import FailedMsg from "../../../Extra/FailedMsg";
import SuccessMsg from "../../../Extra/SuccessMsg";

const StaffStrengthUpdate = ({ Id }) => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const [gridData, setGridData] = useState([]);
  const [error, setError] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://railsetu.in:5020/get_station-staff-strength?station_id=${Id}`,
      );
      if (response.data.status === "ok") {
        setGridData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [Id]);
  const columnHead = [
    `designation`,
    `grade_pay`,
    `sanctioned_strength`,
    `on_roll`,
    `vacancy`,
  ];

  const handleChange = (rowIndex, key, value) => {
    const newData = [...gridData];
    const updatedRow = { ...newData[rowIndex], [key]: value };

    newData[rowIndex] = updatedRow;
    setGridData(newData);
  };

  const sendToBackend = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://railsetu.in:5020/update-station-staff-strength

`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(gridData),
        },
      );
      const data = await res.json();
      setResult(data);
      setShow(true);
      if (data.status === "ok");
    } catch (e) {
      setResult({ status: "failed", message: e.message });
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center mt-12">
      <div className="papaDiv text-start">
        <h5 className="ps-2">
          Update data in table{" "}
          <b style={{ color: "red" }}>" staff strength "</b>
        </h5>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th style={{ width: "50px" }}>Sr No.</th>

              {columnHead.map((head, index) => (
                <th key={index} style={{ border: "1px solid gray" }}>
                  {head.replace(/_/g, " ").toUpperCase()}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {gridData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}</td>

                {columnHead.map((col, colIndex) => (
                  <td key={colIndex}>
                    {col === "designation" ? (
                      <input
                        type="text"
                        value={row[col] || ""}
                        className="form-control"
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="number"
                        className="form-control"
                        value={row[col] || ""}
                        style={{ fontSize: "0.8rem" }}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-3">
        {result?.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>

      <div>
        <button
          className={`m-1 btn btn-sm btn-outline-success ${
            loading ? "disabled" : ""
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default StaffStrengthUpdate;
